import { Node_Type } from "./../ricos-schema/legacy/wix/rich_content/v1";
const videoModals = {
  insertVideo: `${Node_Type.VIDEO}.insertVideo`,
  insertYoutube: `${Node_Type.VIDEO}.insertYoutube`,
  replace: `${Node_Type.VIDEO}.replace`,
  settings: `${Node_Type.VIDEO}.settings`
};
const VIDEO_BUTTONS = {
  alignment: `${Node_Type.VIDEO}.alignment`,
  size: `${Node_Type.VIDEO}.size`
};
const pauseTrigger = { scroll: "scroll" };
export {
  VIDEO_BUTTONS,
  pauseTrigger,
  videoModals
};
//# sourceMappingURL=constants.js.map
